const COMMENTS = [
  {
    name: '影迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20person%20casual%20portrait%2C%20friendly%20smile%2C%20simple%20neutral%20background%2C%20soft%20lighting%2C%20clean%20composition&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    text: '发现五姑娘影院真的太惊喜了！高清不卡顿，片源更新也快。最近追的几部大片都是在这里看的，画质绝对是同类网站里最好的。强烈推荐给所有喜欢看电影的朋友！',
    date: '2026年7月28日',
  },
  {
    name: '小张爱电影',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20portrait%20with%20warm%20expression%2C%20natural%20look%2C%20simple%20soft%20background%2C%20gentle%20lighting%2C%20clean%20minimal%20composition&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    text: '作为一名资深科幻迷，五姑娘影院的科幻片专题真的太棒了。从经典到最新，分类清晰，找片方便。而且完全免费不用注册，这种良心网站必须支持！已经安利给身边所有同事了。',
    date: '2026年7月26日',
  },
  {
    name: '资深影评人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=mature%20Chinese%20man%20portrait%20thoughtful%20expression%2C%20warm%20lighting%2C%20simple%20dark%20background%2C%20professional%20casual%20look%2C%20clean%20composition&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    text: '五姑娘影院电影大全的片库真的惊到我了，很多冷门高分片都能找到。播放流畅度没话说，1080P画质看着就是舒服。每日更新频率也非常靠谱，基本想看的都能找到。观影体验满分！',
    date: '2026年7月25日',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            用户口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自真实影迷的评价，每一句都是对我们的鼓励
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-200/40 rounded-lg border border-background-300/30 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300/50 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    title={`五姑娘影院用户${comment.name}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-200">{comment.name}</div>
                  <div className="text-xs text-foreground-600">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-1 mt-3 text-primary-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}